import React from 'react'

const PptConfirmDialog = ({onContinueClick, onCancelClick}) => {
    return (
        <div className="ppt-confirm-dialog">
            <p>PowerPoint資料を作成しますか？</p>
            <button className="ppt-continue-button" onClick={onContinueClick}>Continue</button>
            <button className="ppt-cancel-button" onClick={onCancelClick}>Cancel</button>
        </div>
    )
}

export default PptConfirmDialog